import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { APIBaseService } from "./api_base.service";
import { domain } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PublicAPI extends APIBaseService {
  namespace = "public";

  async registerDeviceToken(data) {
    const url = `${domain}/${this.namespace}/1/registerDeviceToken`;
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        // this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async register(data) {
    const url = `${domain}/${this.namespace}/register`;
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async verifyOtp(data) {
    const url = `${domain}/${this.namespace}/verifyOtp`;
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }


  async globalSetting() {
    const url = `${domain}/${this.namespace}/globalSetting`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        // this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async accountVerify(username, token) {
    const params = { token };
    const options = { params };
    const url = `${domain}/${this.namespace}/${username}/${token}/accountVerify`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async resendOtp(username, data) {
    const url = `${domain}/${this.namespace}/${username}/resendOtp`;
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async faqList() {
    const url = `${domain}/${this.namespace}/faqList`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async outletList() {
    const url = `${domain}/${this.namespace}/outlets`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  // note to self, "this.getHeader()" is to get jwt
  async getOutlet(id) {
    const url = `${domain}/${this.namespace}/${id}/getOutlet`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async happeningsList() {
    const url = `${domain}/${this.namespace}/happenings`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async outletHappenings(id) {
    const url = `${domain}/${this.namespace}/${id}/outletHappenings`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async withdrawalDetails() {
    const url = `${domain}/${this.namespace}/withdrawalDetails`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async getPosByMenuIdStallId(menuId, stallId) {
    const url = `${domain}/${this.namespace}/${menuId}/${stallId}/getPosByMenuIdStallId`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async menuLoad(menuId) {
    const url = `${domain}/${this.namespace}/${menuId}/menuLoad`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async outletStalls(id) {
    const url = `${domain}/${this.namespace}/${id}/outletStalls`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        // this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async validateOrderingQr(data) {
    const url = `${domain}/${this.namespace}/validateOrderingQr`;
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async getOrderPendingsViaTableId(tableId) {
    const url = `${domain}/${this.namespace}/${tableId}/getOrderPendingsViaTableId`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async callForBill(tableId) {
    const url = `${domain}/${this.namespace}/${tableId}/callForBill`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async orderHold(data) {
    const url = `${domain}/${this.namespace}/orderHold`;
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async getTenant(id) {
    const url = `${domain}/${this.namespace}/${id}/getTenant`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async enterBySelfOrderingCode(selfOrderingCode) {
    const url = `${domain}/${this.namespace}/${selfOrderingCode}/enterBySelfOrderingCode`;
    return this.http.get(url).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
}
